import * as inUseConnection from 'connections/in-use';
import * as inUseTransform from 'transforms/in-use';

export const get = async inUseId => {
  const faqs = await inUseConnection.get(inUseId);
  return faqs.map(inUseTransform.fromFirestore);
};

export const save = async objToSave => {
  const { inUse } = inUseTransform.toFirestore(objToSave);
  await inUseConnection.save(inUse);
};
